import { __awaiter } from "tslib";
import { dispatch } from '@@/store';
import Luban from '@souche-f2e/luban-js';
import * as Sentry from '@sentry/browser';
// import Rdog from '@souche-f2e/rdog-sdk-h5';
// 浏览器低版本不支持 promise.finally chrome > 64
import promiseFinally from 'promise.prototype.finally';
promiseFinally.shim();
// 鲁班埋点
const config = {
    platform: 'PLATFORM_PSGJBHT_WEB',
    debug: false,
    router_mode: 'hash',
};
Luban.load(config);
// sentry
Sentry.init({ dsn: process.env.MUJI_APP_SENTRY_DSN });
// 前端性能监控
// Rdog.init({ pid: 'yyn1nr', env: 'prod' });
export default function bootstrap() {
    return __awaiter(this, void 0, void 0, function* () {
        // 初始化函数，将在整个前端应用渲染前调用
        // 可以在这里进行加载用户信息、初始化数据等操作
        // 获取用户信息，权限信息
        dispatch.global.getAuthZ({});
        dispatch.userInfo.getUserInfo({});
    });
}
